import type { RankedTester, RendererProps } from '@jsonforms/core';
import { useEffect } from 'react';
import { container } from 'src/StaticContainer';

const log = container.get('Logger').getSubLogger({ name: 'NoApplicableJsonFormsRenderer' }, { component: 'trading' });

// Once per page session, so a re-rendering form logs each unmatched element once.
const loggedRendererKeys = new Set<string>();

/** Rank 0: wins only when every other tester reports not applicable (-1). */
export const NoApplicableRendererTester: RankedTester = () => 0;

const getUiSchemaScope = (uischema: RendererProps['uischema']) => {
    if ('scope' in uischema && typeof uischema.scope === 'string') {
        return uischema.scope;
    }

    return undefined;
};

export const NoApplicableRenderer = ({ schema, uischema, path, visible, enabled }: RendererProps) => {
    useEffect(() => {
        const rendererKey = `${path}:${uischema.type}:${getUiSchemaScope(uischema) ?? ''}`;

        if (loggedRendererKeys.has(rendererKey)) {
            return;
        }

        loggedRendererKeys.add(rendererKey);

        log.error({
            message: `No applicable JSONForms renderer found for '${uischema.type}' at path '${path}'`,
            path,
            uiSchemaType: uischema.type,
            uiSchemaScope: getUiSchemaScope(uischema),
            visible,
            enabled,
            uischema,
            schema,
        });
    }, [enabled, path, schema, uischema, visible]);

    if (visible === false) {
        return null;
    }

    return <div className="text-ember-400">No applicable renderer found</div>;
};
